import request from '@/utils/request';

export default {
  getList: data => request.get('/heyhey/dress', { params: data }),
  update: data => request.post('/heyhey/dress', data),
  detail: id => request.get(`/heyhey/dress/${id}`)
};
